import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import GuestHub from "@/pages/GuestHub";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Protected from "@/components/Protected";
import DashboardLayout from "@/pages/dashboard/DashboardLayout";
import Overview from "@/pages/dashboard/Overview";
import HubSettings from "@/pages/dashboard/HubSettings";
import DirectoryPage from "@/pages/dashboard/DirectoryPage";
import ServicesPage from "@/pages/dashboard/ServicesPage";
import BookingsPage from "@/pages/dashboard/BookingsPage";
import AnnouncementsPage from "@/pages/dashboard/AnnouncementsPage";
import BillingPage from "@/pages/dashboard/BillingPage";
import SchedulePage from "@/pages/dashboard/SchedulePage";
import QRKitPage from "@/pages/dashboard/QRKitPage";
import MessagesPage from "@/pages/dashboard/MessagesPage";
import NearbyPage from "@/pages/dashboard/NearbyPage";
import MenuPage from "@/pages/dashboard/MenuPage";
import OrdersPage from "@/pages/dashboard/OrdersPage";
import ComplaintsPage from "@/pages/dashboard/ComplaintsPage";
import GuestsPage from "@/pages/dashboard/GuestsPage";
import PlatformSmtpPage from "@/pages/dashboard/PlatformSmtpPage";
import AnalyticsPage from "@/pages/dashboard/AnalyticsPage";
import UpgradesPage from "@/pages/dashboard/UpgradesPage";
import AdminConsole from "@/pages/AdminConsole";
import RoomsPage from "@/pages/dashboard/RoomsPage";
import ChannelsPage from "@/pages/dashboard/ChannelsPage";
import TablesPage from "@/pages/dashboard/TablesPage";
import CheckinsPage from "@/pages/dashboard/CheckinsPage";
import HousekeepingPage from "@/pages/dashboard/HousekeepingPage";
import ReviewsPage from "@/pages/dashboard/ReviewsPage";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Auth mode="login" />} />
            <Route path="/register" element={<Auth mode="register" />} />
            <Route path="/h/:slug" element={<GuestHub />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/admin" element={<AdminConsole />} />
            <Route
              path="/dashboard"
              element={
                <Protected>
                  <DashboardLayout />
                </Protected>
              }
            >
              <Route index element={<Overview />} />
              <Route path="hub" element={<HubSettings />} />
              <Route path="analytics" element={<AnalyticsPage />} />
              <Route path="guests" element={<GuestsPage />} />
              <Route path="rooms" element={<RoomsPage />} />
              <Route path="channels" element={<ChannelsPage />} />
              <Route path="directory" element={<DirectoryPage />} />
              <Route path="nearby" element={<NearbyPage />} />
              <Route path="services" element={<ServicesPage />} />
              <Route path="schedule" element={<SchedulePage />} />
              <Route path="menu" element={<MenuPage />} />
              <Route path="upgrades" element={<UpgradesPage />} />
              <Route path="orders" element={<OrdersPage />} />
              <Route path="bookings" element={<BookingsPage />} />
              <Route path="tables" element={<TablesPage />} />
              <Route path="checkins" element={<CheckinsPage />} />
              <Route path="housekeeping" element={<HousekeepingPage />} />
              <Route path="reviews" element={<ReviewsPage />} />
              <Route path="complaints" element={<ComplaintsPage />} />
              <Route path="messages" element={<MessagesPage />} />
              <Route path="announcements" element={<AnnouncementsPage />} />
              <Route path="qr" element={<QRKitPage />} />
              <Route path="smtp" element={<PlatformSmtpPage />} />
              <Route path="billing" element={<BillingPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
